class UiMenuController {
  constructor(Permissions, $rootScope) {
    "ngInject";
    const vm = this;

    vm.rootScope = $rootScope;

    vm.menuItems = [
      {
        /* DASHBOARD */
        name: "DASHBOARD",
        route: "dashboard",
        materialIcon: "&#xe871;",
        icon: "../../../assets/images/i_0.svg",
        menuItems: [],
      },
      {
        /* MATCHES */
        name: "MATCHES",
        route: "matches-list",
        materialIcon: "&#xe8e1;",
        icon: "../../../assets/images/i_4.svg",
        menuItems: [],
      },
      {
        /* PLAYERS */
        name: "PLAYERS",
        route: "players",
        materialIcon: "&#xe7fd;",
        icon: "../../../assets/images/i_4.svg",
        menuItems: [],
      },
      {
        /* TEAMS */
        name: "TEAMS",
        route: "teams",
        materialIcon: "&#xe7ef;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_TEAMS,
        menuItems: [],
      },
      {
        /* JUDGES */
        name: "JUDGES",
        route: "judges",
        materialIcon: "&#xe02f;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_JUDGES,
        menuItems: [],
      },
      {
        /* COACHES */
        name: "COACHES",
        route: "coaches",
        materialIcon: "&#xe566;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_COACHES,
        menuItems: [],
      },
      {
        /* STAFF */
        name: "STAFF",
        route: "staff",
        materialIcon: "&#xe7fb;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_STAFF,
        menuItems: [],
      },
      {
        /* TRAINERS */
        name: "TRAINERS",
        route: "trainers",
        materialIcon: "&#xe536;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_TRAINERS,
        menuItems: [],
      },
      // {
      //   /* TRAINING CENTER */
      //   name: "TRAINING_CENTER",
      //   route: "trainingCenter",
      //   materialIcon: "&#xe88a;",
      //   icon: "../../../assets/images/i_4.svg",
      //   permission: Permissions.VIEW_ALL_TRAINING_ENTRIES,
      //   menuItems: [],
      // },
      {
        /* TRAINING CENTER */
        name: "TRAINING_CENTERS",
        route: "trainingCenters",
        materialIcon: "&#xe88a;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_TRAINING_ENTRIES,
        menuItems: [],
      },
      {
        /* LEAGUES */
        name: "LEAGUES",
        route: "leagues",
        materialIcon: "&#xe1b2;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_LEAGUES,
        menuItems: [],
      },
      {
        /* TRANSFERS */
        name: "TRANSFERS",
        route: "transfers",
        materialIcon: "&#xe8d4;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_ALL_TRANSFERS,
        menuItems: [],
      },
      {
        /* PAYMENTS */
        name: "PAYMENTS",
        route: "payments",
        materialIcon: "&#xe227;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_FINANCIAL,
        visibleItems: false,
        menuItems: [
          {
            name: "PAYMENT_ITEMS",
            route: "payments-list",
            visibleItems: false,
            menuItems: [],
          },
          {
            name: "TEAM_PAYMENTS",
            route: "payments-team",
            visibleItems: false,
            menuItems: [],
          },
          {
            name: "PLAYER_PAYMENTS",
            route: "payments-player",
            visibleItems: false,
            menuItems: [],
          },
          {
            name: "TEAM_PAYMENTS_LIST",
            route: "payments-team-list",
            visibleItems: false,
            permission: Permissions.VIEW_ALL_MOVEMENTS_TEAM,
            menuItems: [],
          },
          {
            name: "PLAYER_PAYMENTS_LIST",
            route: "payments-player-list",
            visibleItems: false,
            permission: Permissions.VIEW_ALL_MOVEMENTS_PLAYER,
            menuItems: [],
          },
        ],
      },
      {
        /* REPORTS */
        name: "REPORTS",
        route: "reports",
        materialIcon: "&#xe24d;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_REPORTS,
        menuItems: [],
      },
      {
        /* ROLES */
        name: "ROLES",
        route: "roles",
        materialIcon: "&#xe8c0;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.EDIT_ROLES,
        menuItems: [],
      },
      {
        /* USERS */
        name: "USERS",
        route: "users",
        materialIcon: "&#xe55a;",
        icon: "../../../assets/images/i_4.svg",
        permission: Permissions.VIEW_USERS,
        menuItems: [],
      },
    ];
  }
}

export default UiMenuController;



// WEBPACK FOOTER //
// ./client/app/common/uiMenu/uiMenu.controller.js